import React from 'react';

import { useIntl } from 'react-intl';

import { useCreateMembershipType } from 'src/features/membershipType/api/useCreateMembershipType';
import { LIST_MEMBERSHIP_TYPES_RESOURCE } from 'src/features/membershipType/api/useListMembershipTypes';
import MembershipTypeFormModal from 'src/features/membershipType/components/forms/MembershipTypeFormModal.tsx';
import { membershipTypeMessages } from 'src/features/membershipType/utils/messages';
import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { useParking } from 'src/providers/ParkingProvider';

interface MembershipTemplateFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreateMembershipTypeFormModal<TData>({ className, semantics }: MembershipTemplateFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { parkingId } = useParking();
    const { mutate, isPending } = useCreateMembershipType({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_MEMBERSHIP_TYPES_RESOURCE] });
            toast({
                title: formatMessage(membershipTypeMessages.createTemplateSuccess),
                description: formatMessage(membershipTypeMessages.createTemplateSuccessDescription),
            });
        },
    });

    return (
        <MembershipTypeFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(membershipTypeMessages.addTemplateModalSubtitle)}
        />
    );
}

export default CreateMembershipTypeFormModal;
